module.exports = __webpack_public_path__ + "source-sans-pro-v10-latin-ext_latin-regular.a7bf5da8d9c08c3493bf.ttf";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-regular.ttf
// module id = ../../../../../src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-regular.ttf
// module chunks = styles